var scope_0 = require('/home/runner/work/technical-documentation/technical-documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1f2694060be43475976b9dc501944731.js').default;
var scope_1 = require('/home/runner/work/technical-documentation/technical-documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99ff58f2d532b0e0477b11ab06825ec1.js').default;
var scope_2 = require('/home/runner/work/technical-documentation/technical-documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    